import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "page-content-inner box has-background-grey-dark" }
const _hoisted_2 = { class: "light-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VSimpleDatatables = _resolveComponent("VSimpleDatatables")!
  const _component_SidebarLayout = _resolveComponent("SidebarLayout")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_SidebarLayout, { theme: "labels-hover" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title-wrap" }, [
            _createElementVNode("h1", { class: "title mb-3" }, "Orders List")
          ], -1)),
          _createElementVNode("div", null, [
            _createVNode(_component_VSimpleDatatables, null, {
              default: _withCtx(() => [
                _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      scope: "col",
                      "data-sortable": "true"
                    }, "Order Description"),
                    _createElementVNode("th", { scope: "col" }, "Drop")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (row, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(row['order_description']), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(row['drop']), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}